export enum CompanyEmailNotifications {
    None = 0,
    TimeReport = 1,
    Application = 2,
    All = 3
}